import homeObjOneImg from "../../images/ObjOneImg.jpg";
import homeObjTwoImg from "../../Resume/Resume_Short_Final.png";
import resume2025 from "../../Resume/Resume_BDO_2025Q2-1.png";

export const homeObjOne = {
  id: "about",
  to: "/contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Hi, Nice to meet you!",
  headline: "I am Brian Oh",
  description:
    "Software Engineer who enjoys building scalable systems and optimizing platform performance. I’m passionate about building systems and motivated to make services more reliable, accessible, and useful for people — and ultimately contribute to enhancing the quality of life for others through technology. Outside of engineering, I enjoy skiing, swimming, and I’m currently learning tennis. I like staying active and exploring new challenges both in sports and in technology.",
  buttonLabel: "Let's talk!",
  imgStart: true,
  img: homeObjOneImg,
  alt: "About",
  href: "http://www.thebdo.tech",
  dark: true,
  primary: true,
  darkText: true,
  link: true,
};

export const homeObjTwo = {
  id: "resume",
  to: "/resume",
  lightBg: true,
  lightText: false,
  lightTextDesc: true,
  topLine: "Resume",
  headline: "Experience Matters",
  description:
    `Currently working as a Software Engineer at eBay, 
    where I focus on backend systems and platform optimization. 
    I also enjoy building personal projects to explore new ideas, deepen my technical skills, and stay curious outside of work. 
    `,
  buttonLabel: "Resume (Last Updated: Apr 2025)",
  imgStart: false,
  img: resume2025,
  alt: "resume",
  href: "https://drive.google.com/file/d/1eqxRHEUgvluq2aDksezNixzCDcAwQadj/view?usp=sharing",
  dark: true,
  primary: true,
  darkText: true,
  link: true,
};

// export const homeObjTwo = {
//     id: 'about',
//     lightBg: true,
//     lightText: true,
//     lightTextDesc: true,
//     topLine: 'About Brian',
//     headline: 'Unlimited',
//     description: "GEATEEE",
//     buttonLabel: 'Get Started',
//     imgStart: false,
//     dark: true,
//     primary: true,
//     darkText: false,
//     href: "/"
// };

// export const homeObjThree = {
//     id: 'about3',
//     lightBg: false,
//     lightText: true,
//     lightTextDesc: true,
//     topLine: 'About Brian',
//     headline: 'Unlimited',
//     description: "GEATEEE",
//     buttonLabel: 'Get Started',
//     imgStart: false,
//     dark: true,
//     primary: true,
//     darkText: false,
//     href: "/"
// };
